import { BaseBus } from "./BaseBus";

export class v_UserScorecardsBus extends BaseBus
{
     featureId: any;
     featureName: string;
     sortOrder: number;
     userId: any;
}
